import config from '../repositories/firebase/config';

const CLOUD_STORAGE_URL = `https://storage.googleapis.com/${config.storageBucket}`;

export default (path: string) => {
  return `${CLOUD_STORAGE_URL}${path}`;
};
